<div class="subscription-dialog" data-testid="sub-delete-container">

  <h1 ev-dialog-title>
    {{ languageService.languageJSON.SubscriptionsDialog_CancelSubscription }}
  </h1>
  <div ev-dialog-content>
    <div class="logo">
      <img src="assets/icons/dark/logo/ev_navigation_logo.png" />
      @if (!type.includes('proplus.')) {
        <h2>PRO</h2>
      }
      @if (type.includes('proplus.')) {
        <img id="proplus-icon" src="assets/icons/default/ui/pro_logo.svg" />
      }
    </div>

    <div class="content">
      <p [innerHTML]="deleteSubscriptionDescription"></p>

            <p class="grey" [innerHTML]="sorryToSeeYouLeaveMessage"></p>
        </div>

  </div>
  <div ev-dialog-actions>
    <button class="ev-button primary" mat-button data-testid="sub-delete-confirm-btn" (click)="delete()">{{
    languageService.languageJSON.Global_Delete }}</button>
    <button class="ev-button" mat-button data-testid="sub-delete-cancel-btn" (click)="close()">{{
    languageService.languageJSON.Global_Cancel }}</button>
  </div>

</div>